import { UseCase } from '@core/base/use-case';
import { CancelCashOutRequestEntity } from '@shared/core/entities/cancel-cash-out-request.entity';
import { CancelCashOutRepository } from '@shared/core/repositories/cancel-cash-out/cancel-cash-out.repository';
import { CancelCashOutResponseEntity } from '@shared/core/entities';

export class CancelCashOutUseCase implements UseCase<CancelCashOutRequestEntity, CancelCashOutResponseEntity> {

  constructor(
    private readonly cancelCashOutRepository: CancelCashOutRepository
  ) {
  }

  execute(params: CancelCashOutRequestEntity): Promise<CancelCashOutResponseEntity> {
    return this.cancelCashOutRepository.cancelTransaction(params);
  }
}
